__webpack_require__.p = "https://score.magalu.com/";